import type { ChatExploreCategory, ChatExploreCategoryKey } from 'tripPlanner/config/exploreCategories'
import { chatExploreCategories } from 'tripPlanner/config/exploreCategories'

/** Renders the merged nearby + explore list rather than a `{category} near {place}` search. */
export const THINGS_TO_DO_DEFAULT_CATEGORY_KEY: ChatExploreCategoryKey = 'top-attractions'

// Sports is deliberately absent: stadiums in Sydney, a bowling club in Kiama.
const THINGS_TO_DO_CATEGORY_KEYS = new Set<ChatExploreCategoryKey>([
  THINGS_TO_DO_DEFAULT_CATEGORY_KEY,
  'restaurants',
  'cafes',
  'parks',
  'shopping',
  'museums',
  'bars',
  'beaches',
])

export const thingsToDoCategories: Array<ChatExploreCategory> = chatExploreCategories.filter(
  (category) => THINGS_TO_DO_CATEGORY_KEYS.has(category.key),
)

/** The filter set above is seeded with the default key, so the lookup cannot miss. */
export const THINGS_TO_DO_DEFAULT_CATEGORY: ChatExploreCategory =
  thingsToDoCategories.find((category) => category.key === THINGS_TO_DO_DEFAULT_CATEGORY_KEY) ??
  thingsToDoCategories[0]
